import { render, staticRenderFns } from "./cuentasPorpagar.vue?vue&type=template&id=073fe399&"
import script from "./cuentasPorpagar.vue?vue&type=script&lang=js&"
export * from "./cuentasPorpagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports